import Vue from 'vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import Vue2Editor from "vue2-editor";

Vue.use(Vuetify)
Vue.use(Vue2Editor);

const opts = {
    icons: {
        iconfont: 'mdi'
    }
}

export default new Vuetify(opts)